import React, {
  forwardRef,
  useState,
  MouseEventHandler,
  useEffect,
} from 'react';
import noop from 'lodash/noop';
import { TextFieldProps } from '../main';
import { ClearTextButton } from '../clear-text-button';
import styles from './extended-text-fields.module.scss';
import cn from 'classnames';
import { getBaseCompByType } from './helpers';

export type ClearProps = {
  onClear?: MouseEventHandler<HTMLButtonElement>;
};

export type TextFieldWithClearProps = TextFieldProps & ClearProps;

type ChangeEvent = TextFieldProps['onChange'];

export const TextFieldWithClear = forwardRef<
  HTMLInputElement,
  TextFieldWithClearProps
>(
  (
    {
      value,
      onChange = noop,
      onClear = noop,
      children,
      className,
      type = 'text',
      ...textFieldProps
    },
    ref,
  ) => {
    const InputComponent = getBaseCompByType(type);
    const [inputValue, setInputValue] = useState(value);

    useEffect(() => {
      setInputValue(value);
    }, [value]);

    const clearValue: MouseEventHandler<HTMLButtonElement> = (event) => {
      setInputValue('');
      onClear(event);
      onChange('', { event });
    };

    const handleChange: ChangeEvent = (value, options) => {
      setInputValue(value);
      onChange(value, options);
    };

    return (
      <InputComponent
        {...textFieldProps}
        ref={ref}
        value={inputValue}
        onChange={handleChange}
        flexedStyle={false}
        className={cn(styles.inputWithIcon, styles.inputWithClear, className)}
        type={type}
      >
        <ClearTextButton hidden={!inputValue} onClick={clearValue} />
        {children}
      </InputComponent>
    );
  },
);
